<template>
  <div>
    <h2>New mass pending follow link</h2>

    <form @submit.prevent="addPendingFollowLink">

      <div class="form-group">
        <label for="conf_str">Conf (example: @pendings/alpha_testers_search)</label>
        <input v-model="confStr" id="conf_str" class="form-control" required>
      </div>

      <div class="form-group">
        <label for="players">Player ids (delimitered with ,)</label>
        <textarea
          v-model="playersIdsStr"
          id="players"
          class="form-control"
          rows="5"
          required
        />
      </div>

      <b-button :to="{name: 'players_pendings'}">Cancel</b-button>

      <delayed-action-button
        type="submit"
        variant="primary"
        :enabled="canInteract"
        :running="adding"
        idleLabel="Create"
        runningLabel="Creating"
      />
    </form>
  </div>
</template>

<script>
import notifier from '../notifier.js';
import { HTTP } from '../http-common.js';
import { parsePlayersIdsDelimitedByComma } from '../model/player.js';

import DelayedActionButton from './DelayedActionButton.vue';

export default {
  name: 'PlayersPendingAddFollowLink',

  components: {
    DelayedActionButton,
  },
  

  data() {
    return {
      confStr: '',

      playersIdsStr: '',

      adding: false,
    };
  },

  computed: {
    canInteract() {
      return !this.adding;
    },
  },

  methods: {
    addPendingFollowLink() {
      if(this.adding) {
        return;
      }

      notifier.deleteSenderNotifications(this);

      const normalizedPlayersIdsStrResult = this.getNormalizedPlayersIdsStr();
      if(normalizedPlayersIdsStrResult.error !== null) {
        notifier.showError(normalizedPlayersIdsStrResult.error, {sender: this});
        return;
      }

      this.adding = true;

      const formData = new FormData();
      formData.set('players_ids', normalizedPlayersIdsStrResult.playersIdsStr);

      const trimmedConfStr = this.confStr.trim();
      if(trimmedConfStr.length > 0) {
        formData.set('conf_str', trimmedConfStr);
      }

      HTTP.post('/players/pending/add_follow_link', formData)
      .then(() => {
        notifier.showSuccessAfterTransition('Pending added.');
        this.$router.push({name: 'players_pendings'});
      })
      .catch(e => {
        this.adding = false;
        notifier.showError(e.response.data, {sender: this});
      });
    },

    getNormalizedPlayersIdsStr() {
      const playersIdsStrTrimmed = this.playersIdsStr.trim();
      if(playersIdsStrTrimmed.length === 0) {
        return {
          playersIdsStr: null,
          error: new Error('Players ids must be specified.'),
        };
      }

      // Дубликаты допустимы.
      // Это нужно для случая, когда некоторым игрокам нужно выдать предмет несколько раз (т.е. они заплатили несколько раз).
      const playersIdsResult = parsePlayersIdsDelimitedByComma(playersIdsStrTrimmed);
      if(playersIdsResult.error !== null) {
        return {
          playersIdsStr: null,
          error: playersIdsResult.error,
        };
      }

      return {
        playersIdsStr: playersIdsResult.playersIds.join(','),
        error: null,
      };
    },
  },
}
</script>
